<template lang="pug">
  ul(v-if="itens.length")
    li(v-for="item of itens")
      slot(v-bind="item")
</template>

<script>
  export default {

    props: {
      itens: { type: Array, required: false }
    }

  }
</script>



// WEBPACK FOOTER //
// BaseListagem.vue?710bf760